import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThirdPartyScript } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { ConsentType } from '@core/services/cookie-consent/cookie-consent.config';
import { CookieConsentService } from '@core/services/cookie-consent/cookie-consent.service';
import { NoConsentComponent } from '@shared/cookie-consent-required/no-consent/no-consent.component';
import { IframeLoaderComponent } from '@features/third-party/iframe-loader/iframe-loader.component';
import { MetaLiveShoppingComponent } from '@features/third-party/meta-live-shopping/meta-live-shopping.component';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-third-party-script',
    templateUrl: './third-party-script.component.html',
    styleUrls: ['./third-party-script.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, MetaLiveShoppingComponent, IframeLoaderComponent, NoConsentComponent, AsyncPipe, NgTemplateOutlet]
})
export class ThirdPartyScriptComponent {
    public static readonly ref: string = 'thirdPartyScript';
    public readonly consentType = ConsentType;

    @Input() public data: ThirdPartyScript;

    constructor(public readonly cookieConsentService: CookieConsentService) {}
}
